import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

import { getColor, getSize } from '@lib/common';
import styled from '@xstyled/styled-components';
import { useMemo, useState } from 'react';
import { Select } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, EyeFilled } from '@ant-design/icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledBlankAnswer = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: ", ";\n  padding: ", " ", ";\n  margin: 0 ", ";\n  border: 1px solid #cbd5e1;\n  background-color: ", ";\n  border-radius: ", ";\n  min-height: 36px;\n  font-size: ", ";\n  color: #334155;\n  white-space: nowrap;\n"])), getSize('padding8'), getSize('padding8'), getSize('padding12'), getSize('padding4'), function (_ref) {
  var $status = _ref.$status;
  if ($status === 'correct') return getColor('successBgActive');
  if ($status === 'incorrect' || $status === 'skipped') return getColor('errorBgActive');
  return '#ffffff';
}, getSize('radiusSm'), getSize('typo14'));
var StyledStatusIcon = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  flex-shrink: 0;\n"])), getSize('typo16'), function (_ref2) {
  var $status = _ref2.$status;
  if ($status === 'correct') return getColor('successActive');
  if ($status === 'incorrect' || $status === 'skipped') return getColor('errorActive');
  return '#94a3b8';
});
var IndexCircle = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  border-radius: 50%;\n  background-color: ", ";\n  color: ", ";\n  font-size: ", ";\n  font-weight: 700;\n  line-height: 1;\n  flex-shrink: 0;\n"])), getSize('padding24'), getSize('padding24'), getColor('fillIntActive'), getColor('fillBgWhite'), getSize('typo12'));
var DropdownHeader = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding: ", " ", ";\n  border-bottom: 1px solid #e5e7eb;\n  background: #f9fafb;\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  cursor: default;\n  user-select: none;\n\n  .header-icon {\n    color: ", ";\n    font-size: ", ";\n  }\n\n  .header-text {\n    font-size: ", ";\n    font-weight: 600;\n    color: ", ";\n  }\n"])), getSize('padding8'), getSize('padding12'), getSize('padding8'), getColor('fillIntActive'), getSize('typo14'), getSize('typo14'), getColor('fillIntActive'));
var DropdownOptionWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  .ant-select-item {\n    display: flex;\n    align-items: flex-start;\n    gap: ", ";\n    padding: ", " ", " !important;\n    cursor: default !important;\n    pointer-events: none !important;\n    white-space: normal !important;\n    word-wrap: break-word !important;\n  }\n\n  .ant-select-item-option {\n    cursor: default !important;\n  }\n\n  .ant-select-item-option-content {\n    pointer-events: none !important;\n    white-space: normal !important;\n    word-wrap: break-word !important;\n    flex: 1;\n  }\n"])), getSize('padding8'), getSize('padding8'), getSize('padding16'));
var OptionLabelWrapper = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  color: #000;\n  line-height: 1.5;\n"])));
var StyledSelect = styled(Select)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  min-width: 150px;\n  max-width: 250px;\n  width: auto;\n\n  .ant-select-selector {\n    height: 40px !important;\n    border: 2px solid #cbd5e1 !important;\n    border-radius: 12px !important;\n    padding: ", " ", " !important;\n    transition: border-color 0.2s ease !important;\n    font-size: ", " !important;\n    line-height: ", " !important;\n    color: ", " !important;\n    background: ", " !important;\n  }\n\n  .ant-select-selection-placeholder {\n    line-height: ", " !important;\n    color: #9ca3af !important;\n  }\n\n  &:not(.ant-select-disabled):hover .ant-select-selector {\n    border-color: ", " !important;\n  }\n\n  &.ant-select-focused .ant-select-selector {\n    border-color: ", " !important;\n    box-shadow: none !important;\n  }\n"])), getSize('padding8'), getSize('padding12'), getSize('typo14'), getSize('padding20'), getColor('contentTitle'), getColor('fillBgWhite'), getSize('padding24'), getColor('fillIntActive'), getColor('fillIntActive'));
export var FillInBlankAnswerPreview = function FillInBlankAnswerPreview(_ref3) {
  var index = _ref3.index,
      answerId = _ref3.answerId,
      question = _ref3.question,
      status = _ref3.status;

  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var allAnswerOptions = useMemo(function () {
    var _fibQuestion$answers;

    if (!question || !answerId) return [];
    var fibQuestion = question; // Find the specific answer for this blank

    var answer = fibQuestion === null || fibQuestion === void 0 ? void 0 : (_fibQuestion$answers = fibQuestion.answers) === null || _fibQuestion$answers === void 0 ? void 0 : _fibQuestion$answers.find(function (ans) {
      return ans.id.toString() === answerId;
    });
    if (!(answer !== null && answer !== void 0 && answer.description)) return []; // Split by "|" delimiter to get individual tags/descriptions for this answer only

    var descriptions = answer.description.split('|').map(function (desc) {
      return desc.trim();
    }).filter(function (desc) {
      return desc.length > 0;
    }); // Convert to array and create options with index

    return descriptions.map(function (desc, idx) {
      return {
        label: desc,
        value: desc,
        index: idx + 1
      };
    });
  }, [question, answerId]); // Don't trigger onChange when option is selected

  var handleChange = function handleChange() {// Do nothing - prevent any change event
  };

  var placeholderText = "".concat(allAnswerOptions.length, " ").concat(allAnswerOptions.length > 1 ? 'answers' : 'answer', " ");

  var dropdownRender = function dropdownRender(menu) {
    return /*#__PURE__*/_jsxs(DropdownOptionWrapper, {
      children: [/*#__PURE__*/_jsxs(DropdownHeader, {
        children: [/*#__PURE__*/_jsx(EyeFilled, {
          className: "header-icon"
        }), /*#__PURE__*/_jsx("span", {
          className: "header-text",
          children: "Valid answers"
        })]
      }), menu]
    });
  };

  return /*#__PURE__*/_jsxs(StyledBlankAnswer, {
    children: [/*#__PURE__*/_jsx(IndexCircle, {
      children: index
    }), /*#__PURE__*/_jsx(StyledSelect, {
      onChange: handleChange,
      onSelect: function onSelect() {
        return false;
      },
      placeholder: placeholderText,
      options: allAnswerOptions.map(function (option) {
        return {
          label: /*#__PURE__*/_jsx(OptionLabelWrapper, {
            children: /*#__PURE__*/_jsxs("span", {
              children: [/*#__PURE__*/_jsxs("strong", {
                children: [option.index, "."]
              }), " ", option.label]
            })
          }),
          value: option.value,
          disabled: true // Disable all options to prevent selection

        };
      }),
      filterOption: function filterOption(input, option) {
        var _option$label;

        return ((_option$label = option === null || option === void 0 ? void 0 : option.label) !== null && _option$label !== void 0 ? _option$label : '').toLowerCase().includes(input.toLowerCase());
      },
      open: open,
      onDropdownVisibleChange: setOpen,
      dropdownRender: dropdownRender
    }), status === 'correct' && /*#__PURE__*/_jsx(StyledStatusIcon, {
      $status: status,
      children: /*#__PURE__*/_jsx(CheckCircleOutlined, {})
    }), status === 'incorrect' && /*#__PURE__*/_jsx(StyledStatusIcon, {
      $status: status,
      children: /*#__PURE__*/_jsx(CloseCircleOutlined, {})
    })]
  });
};